import React from 'react';
import { Calendar } from 'lucide-react';

// 04-enforce.md 4.1 -- extraído de NewEvent.jsx: el selector de calendario (trigger + dropdown,
// con fallback a "calendario del organizador" / assignee de tarea cuando el calendario del
// evento no está en la lista del invitado). Presentacional.
const NeCalendarSelector = ({ calendars, selectedCalendarId, onSelect, isOpen, onToggleOpen, isInvited, initialData, t }) => {
  const selected = selectedCalendarId ? calendars.find(c => c.id === selectedCalendarId) : null;

  const renderTriggerContent = () => {
    if (!selectedCalendarId) return t('eventModal.loadingCalendars');
    if (selected) {
      return (
        <>
          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: selected.color || '#3b82f6', display: 'inline-block' }} />
          <span>{selected.name}</span>
          <span style={{ background: '#333', padding: '2px var(--space-2)', borderRadius: 'var(--radius-sm)', fontSize: '10px', color: '#aaa', marginLeft: 'auto' }}>
            ...{selected.id.slice(-4)}
          </span>
        </>
      );
    }
    if (initialData?.type === 'task' && initialData?.task_assignee) {
      return (
        <>
          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#10b981', display: 'inline-block' }} />
          <span>{initialData.task_assignee}</span>
        </>
      );
    }
    return (
      <>
        <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#888', display: 'inline-block' }} />
        <span style={{ fontStyle: 'italic', color: '#aaa' }}>
          {initialData?.calendarName || t('eventModal.organizerCalendar')}
        </span>
      </>
    );
  };

  return (
    <div className="ne-row" style={{ alignItems: 'center', zIndex: 10 }}>
      <Calendar size={18} className="ne-icon" />
      <div className="ne-custom-select-container" style={{ position: 'relative', flex: 1 }}>
        <div
          className="ne-custom-select-trigger"
          onClick={() => !isInvited && onToggleOpen()}
          style={{
            display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
            padding: 'var(--space-2) 0', cursor: isInvited ? 'not-allowed' : 'pointer', color: '#e0e0e0', fontSize: '14px',
            opacity: isInvited ? 0.5 : 1
          }}
        >
          {renderTriggerContent()}
        </div>

        {isOpen && (
          <div className="ne-custom-dropdown-options" style={{
            position: 'absolute', top: '100%', left: 0, right: 0,
            background: '#1a1a1a', border: '1px solid #333', borderRadius: 'var(--radius-md)',
            zIndex: 100, boxShadow: '0 4px 12px rgba(0,0,0,0.3)', marginTop: 'var(--space-1)',
            maxHeight: '200px', overflowY: 'auto'
          }}>
            {calendars.map(cal => (
              <div
                key={cal.id}
                onClick={() => onSelect(cal.id)}
                className="ne-custom-option"
                style={{
                  padding: 'var(--space-2) var(--space-3)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
                  cursor: 'pointer', borderBottom: '1px solid #222'
                }}
              >
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: cal.color || '#3b82f6', display: 'inline-block' }} />
                <span style={{ color: '#eee', fontSize: '13px' }}>{cal.name}</span>
                <span style={{ background: '#333', padding: '2px var(--space-2)', borderRadius: 'var(--radius-sm)', fontSize: '10px', color: '#aaa', marginLeft: 'auto' }}>
                  ...{cal.id.slice(-4)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NeCalendarSelector;
